import moment from 'moment';
import { get } from 'lodash';
import type { Validator } from 'react-admin';

export const notLaterThan = (
  otherSource: string,
  message: string,
): Validator => (value, allValues) => {

  const other = get(allValues, otherSource);
  if (!value || !other) return undefined;

  if (moment(value).startOf('day').isAfter(moment(other).startOf('day'))) {

    return message;

  }

  return undefined;

};

export const notLaterThanToday = (
  message: string,
): Validator => (value) => {

  if (!value) return undefined;

  if (moment(value).startOf('day').isAfter(moment().startOf('day'))) {

    return message;

  }

  return undefined;

};
